/**
 * Authoritative list of reporting managers for leave requests.
 * Name is the display label; email is looked up from the Employee table by name.
 */
export const LEAVE_MANAGERS = [
    'Gopal',
    'Vinobha',
    'Sai Mohan Reddy',
    'Sandeep',
    'R.Pradheep',
    'Satish Kumar K',
    'Vinod Kumar K B',
    'Hemanth',
];

/**
 * Hardcoded HR CC contacts for leave notifications.
 * Emails are fixed — not looked up from Employee table.
 */
export const LEAVE_HR_CC = [
    { label: 'Pooja Revanaki – HR Bangalore', email: 'pooja.revanaki@adityatrading.com' },
    { label: 'Tirtha – HR Pune', email: 'tirtha@adityatrading.com' },
    { label: 'Akash – HR Salem', email: 'akash@adityatrading.com' },
    { label: 'Geetanjali – HR Hyderabad', email: 'geetanjali@adityatrading.com' },
    { label: 'Preethi – HR Chennai', email: 'preethi@adityatrading.com' },
];

/**
 * Leave balance caps — mirror the backend policy in hr/candidates/constants.py.
 * Confirmed/Active employees use a sick + casual split capped at 10 each.
 * Probation employees use a single 6-day total bucket; sick/casual must be 0.
 */
export const LEAVE_CAPS = {
    CONFIRMED: { sick: 10, casual: 10, total: 20 },
    PROBATION: { sick: 0,  casual: 0,  total: 6  },
};

export const CONFIRMED_STATUSES = ['Confirmed', 'Active'];
export const PROBATION_STATUSES = ['Probation', 'probation'];
